// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Config } from '../.env.js';
// import { useLocation, useNavigate } from 'react-router-dom';
// import BankDropdown from './bank.js';
// import "./style.css";
// import IFSCSearch from './findifsc.js';
// import Header from './Header.js';
// import Footer from './Footer.js';
// const Form2 = () => {
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const campaignName = queryParams.get('campaignName');
//   const navigate = useNavigate();
//   const initialFormState = {

//     AuthCustomSocial: '',
//     productSS: '',
//     order: '',
//     city: '',
//     pinCode: '',
//     UPI: '',
//     paymentMethod: '',
//     accountNumber: '',
//     ifsc: '',
//     beneficiaryName: '',
//     bankName: '',
//     whatsappGroup: '',
//     inputValue: '',
//     inputValue1: '',
//     inputValue2: '',
//     inputValue3: '',
//     inputValue4: '',
//     starRating: '',
//     sellarFeedbackScreenshot: '',
//     invoiceReceived: '',
//     invoiceNumber: '',
//     profileVisibility: '',
//     product1: '',
//     contactId: ''

//   };

//   const [data, setData] = useState({});
//   // const [fullName, setFullName] = useState('');
//   // const [orderId, setOrderId] = useState('');
//   // const [upiId, setUpiId] = useState('');
//   // const [bankAccountNumber, setBankAccountNumber] = useState('');
//   // const [ifscCode, setIfscCode] = useState('');
//   // const [beneficiaryName, setBeneficiaryName] = useState('');
//   // const [bankName, setBankName] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [showMessage, setShowMessage] = useState(false);
//   const [selectedBank, setSelectedBank] = useState('');
//   const [products, setProducts] = useState([{ name: '', quantity: '', ss: null, amount: '' }]);
//   const [formData, setFormData] = useState(() => {
//     // Load initial form data from localStorage
//     const savedFormData = localStorage.getItem('formData');
//     const storedUserId = localStorage.getItem("loggedInUserId");

//     return savedFormData ? JSON.parse(savedFormData) : {
//       AuthCustomSocial: '',
//       productSS: '',
//       order: '',
//       city: '',
//       pinCode: '',
//       UPI: '',
//       paymentMethod: '',
//       accountNumber: '',
//       ifsc: '',
//       beneficiaryName: '',
//       bankName: '',
//       whatsappGroup: '',
//       inputValue: '',
//       inputValue1: '',
//       inputValue2: '',
//       inputValue3: '',
//       inputValue4: '',
//       starRating: '',
//       sellarFeedbackScreenshot: '',
//       invoiceReceived: '',
//       invoiceNumber: '',
//       profileVisibility: '',
//       product1: '',
//       contactId: ''
//     };
//   });
//   useEffect(() => {
//     localStorage.setItem('formData', JSON.stringify(formData));
//   }, [formData]);
//   useEffect(() => {
//     if (campaignName) {
//       const fetchData = async () => {
//         try {
//           const response = await axios.get(`${Config.API_URL}/api/templategetREfund/${campaignName}`);


//           console.log('Fetched data:', response.data);

//           const filteredData = response.data.reduce((acc, item) => ({ ...acc, ...item }), {});

//           setData(filteredData);
//         } catch (error) {
//           console.error('Error fetching form data:', error);
//         }
//       };
//       fetchData();
//     }
//   }, [campaignName]);
//   // const handleClearStorage = () => {
//   //   localStorage.clear();
//   //   setFormData({
//   //     AuthCustomSocial: '',
//   //     AuthYouTube: '',
//   //     AuthTwitter: '',
//   //     AuthFacebook: '',
//   //     AuthInstagram: '',
//   //     productSS: '',
//   //     order: '',
//   //     city: '',
//   //     pinCode: '',
//   //     UPI: '',
//   //     paymentMethod: '',
//   //     accountNumber: '',
//   //     ifsc: '',
//   //     quantity: '',
//   //     beneficiaryName: '',
//   //     bankName: '',
//   //     whatsappGroup: '',
//   //     inputValue: '',
//   //     inputValue1: '',
//   //     inputValue2: '',
//   //     inputValue3: '',
//   //     inputValue4: '',
//   //     starRating: '',
//   //     sellerFeedbackScreenshot: '',
//   //     invoiceReceived: '',
//   //     invoiceNumber: '',
//   //     profileVisibility: '',
//   //     product1: '',
//   //     contactId: ''
//   //   });
//   // };
//   const handleClearStorage = () => {
//     localStorage.removeItem('formData'); // ❌ Don't clear entire localStorage
//     setFormData({ ...initialFormState }); // ✅ Reset form only
//   };
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get(`${Config.API_URL}/api/product`, {
//           params: { campaignName }, // Send campaign name as a query parameter
//         });
//         setProducts(response.data); // Set fetched products to state
//       } catch (error) {
//         console.error("Error fetching products:", error);
//         console.log("Error fetching products:", error);
//       }
//     };

//     if (campaignName) {
//       fetchProducts(); // Fetch products when campaignName changes
//     }
//   }, [campaignName]);
//   const handleFormChange = (event) => {
//     const { name, value, type, checked } = event.target;
//     setFormData(prevData => ({
//       ...prevData,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setShowMessage(true);
//     setLoading(true);

//     const userId = localStorage.getItem("loggedInUserId");
//     if (!userId) {
//       alert("User ID not found. Please log in again.");
//       setLoading(false);
//       return;
//     }

//     // Add userId to formData
//     const completeFormData = {
//       ...formData,
//       userId: userId, // Add userId here
//     };

//     const formPayload = new FormData();
//     for (const key in completeFormData) {
//       formPayload.append(key, completeFormData[key]);
//     }

//     if (completeFormData.inputValue3) {
//       formPayload.append("productSS", completeFormData.inputValue3);
//     }

//     try {
//       const response = await axios.post(`${Config.API_URL}/api/submit-form`, formPayload, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       console.log('Form submitted successfully:', response.data);
//       setTimeout(() => {
//         navigate('/live-user');
//       }, 1500);
//     } catch (error) {
//       console.error('Error submitting form:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         inputValue3: file,  // Use appropriate state key for each file input
//       }));
//     }
//   };

//   const handleFileUpload1 = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         inputValue4: file,
//       }));
//     }
//   };

//   const handleFileUpload2 = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         sellarFeedbackScreenshot: file,
//       }));
//     }
//   };
//   const handleFileUpload3 = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         invoiceReceived: file,
//       }));
//     }
//   };
//   const handleBankChange = (e) => {
//     const value = e.target.value;
//     setSelectedBank(value);
//     setFormData((prevData) => ({
//       ...prevData,
//       bankName: value,  // ✅ This will include bankName in form submission
//     }));
//   };

//   const handleCancel = () => {
//     localStorage.removeItem('formData'); // Clear only form data
//     setFormData({ ...initialFormState }); // Reset to defaults
//     window.location.reload();
//   };
//   const fieldStyle = {
//     width: "100%",
//     borderRadius: "4px",
//   };

//   return (
//     <>
//       <Header />
//       <div className='card' style={{ width: "1248px", left: "35px", right: "40px" }}>
//         {loading && (
//           <div className="loader-overlay">
//             <div className="loader"></div>
//           </div>
//         )}
//         <form onSubmit={handleSubmit}>

//           <div style={{ display: "flex", justifyContent: "center" }}>
//             <h2 style={{ fontFamily: "Roboto", fontWeight: "600", width: "374px", marginTop: "75px" }}>
//               Refund Form
//             </h2>
//           </div>
//           <div style={{ marginLeft: "25px", marginRight: "25px" }}>
//             <h2 style={{ fontFamily: "Roboto", fontWeight: "500", width: "259px", marginTop: "40px" }}>
//               Instructions Before Filling the Form:
//             </h2>
//             <h2 style={{ fontFamily: "Roboto", fontWeight: "500", maxWidth: "1059px", fontSize: "12px", marginTop: "10px" }}>
//               Please fill out all required fields carefully and ensure that your contact, order, and payment details are accurate. Incomplete or incorrect submissions may be rejected. By submitting this form, you confirm that you agree to the terms and conditions of the campaign.
//             </h2>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//                 gap: "20px",
//               }}
//             >
//               <div className="field" style={fieldStyle}>
//                 <label className="label">Contact Id</label>
//                 <div className="control">
//                   <input
//                     className="input"
//                     type="text"
//                     name="contactId"
//                     placeholder="Contact id received via mail"
//                     value={formData.contactId}
//                     onChange={handleFormChange}
//                     required
//                   />
//                 </div>
//               </div>

//               {data.order && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Order Id</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="order"
//                       placeholder="Order Id"
//                       value={formData.order}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.AuthCustomSocial && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.AuthCustomSocial}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="AuthCustomSocial"
//                       placeholder="Account holder name"
//                       value={formData.AuthCustomSocial}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.paymentMethod && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Payment Method</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="paymentMethod"
//                       placeholder="Bank Account or UPI ID"
//                       value={formData.paymentMethod}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.accountNumber && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Bank Account Number</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="accountNumber"
//                       placeholder="Bank Account Number"
//                       value={formData.accountNumber}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           handleFormChange(e);
//                         }
//                       }}
//                       inputMode="numeric"
//                       maxLength={18}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.ifsc && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">IFSC Code</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="ifsc"
//                       placeholder="IFSC Code"
//                       value={formData.ifsc}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.beneficiaryName && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Beneficiary Name</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="beneficiaryName"
//                       placeholder="Beneficiary Name"
//                       value={formData.beneficiaryName}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.bankName && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Bank Name</label>
//                   <BankDropdown selectedBank={selectedBank} handleBankChange={handleBankChange} />
//                 </div>
//               )}

//               {data.UPI && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">UPI ID</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="UPI"
//                       placeholder="UPI ID"
//                       value={formData.UPI}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="inputValue1"
//                       value={formData.inputValue}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue2 && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue2}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="inputValue2"
//                       value={formData.inputValue2}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue3 && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue3}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="inputValue3"
//                       accept="image/*"
//                       onChange={handleFileUpload}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue4 && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue4}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="inputValue4"
//                       accept="image/*"
//                       onChange={handleFileUpload1}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.sellerFeedbackScreenshot && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.sellerFeedbackScreenshot}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="sellarFeedbackScreenshot"
//                       accept="image/*"
//                       onChange={handleFileUpload2}
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.invoiceReceived && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.invoiceReceived}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="invoiceReceived"
//                       accept="image/*"
//                       onChange={handleFileUpload3}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.invoiceNumber && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.invoiceNumber}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="invoiceNumber"
//                       placeholder="Invoice Number"
//                       value={formData.invoiceNumber}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.starRating && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.starRating}</label>
//                   <div className="control">
//                     <div className="select is-fullwidth">
//                       <select
//                         name="starRating"
//                         value={formData.starRating}
//                         onChange={handleFormChange}
//                         required
//                       >
//                         <option value="" disabled>Select Rating</option>
//                         {[1, 2, 3, 4, 5].map((val) => (
//                           <option key={val} value={val}>{val}</option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//               )}


//               {/* )} */}

//               {/* Only render if whatsappGroup is true */}
//               {data.whatsappGroup === true && (
//                 <div className="field">
//                   <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "12px", height: "23px" }}>Have You Joined <img
//                     src="../images/whatsapp (2).png"
//                     alt="Logo"
//                     style={{ height: "13px", width: "13px", objectFit: "contain" }}
//                   /> Whatsapp Group</label>
//                   <label className="radio" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
//                     <input
//                       type="radio"
//                       name="whatsappGroup"
//                       value="yes"
//                       checked={formData.whatsappGroup === 'yes'}
//                       onChange={handleFormChange}
//                       required
//                     />
//                     Yes
//                   </label>
//                   <label className="radio" style={{ marginLeft: "10px", fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
//                     <input
//                       type="radio"
//                       name="whatsappGroup"
//                       value="no"
//                       checked={formData.whatsappGroup === 'no'}
//                       onChange={handleFormChange}
//                     />
//                     No
//                   </label>
//                 </div>
//               )}
//             </div>

//             <div className="field is-small">
//               <label className="checkbox" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", top: "6px" }}>
//                 <input
//                   type="checkbox"
//                   required
//                 />
//                 Agree to{' '}
//                 <a href="//hobo.video/terms-conditions-for-an-influencer" target="_blank" rel="noopener noreferrer" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
//                   Terms and Conditions
//                 </a>
//               </label>
//             </div>
//             <button className="button" onClick={handleClearStorage} style={{
//               marginLeft: "1010px", marginTop: "-90px"
//             }} >
//               Clear all
//             </button>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "20px", // space between buttons
//                 marginTop: "24px",
//               }}
//             >
//               <button
//                 className="button"
//                 type="submit"
//                 style={{ minWidth: "507px", marginLeft: "30px", marginBottom: "15px" }}
//               >
//                 {loading ? <div className="loader"></div> : "Submit"}
//               </button>

//               <button
//                 className="button"
//                 type="button"
//                 onClick={handleCancel} // define this function
//                 style={{ minWidth: "507px", marginLeft: "40px", marginBottom: "15px" }}
//               >
//                 Cancel
//               </button>
//             </div>

//           </div>
//         </form >

//         {showMessage && (
//           <div className="thank-you-message">
//             <h1>Form Submited successfully</h1>
//             <p>Thank you for submitting the form!</p>
//           </div>
//         )
//         }
//       </div >
//       <Footer />
//     </>
//   );
// };
// export default Form2;
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from "react-toastify";
// import { Config } from '../.env.js';
// import { useLocation, useNavigate } from 'react-router-dom';
// import BankDropdown from './bank.js';
// import "./style.css";
// import IFSCSearch from './findifsc.js';
// import Header from './Header.js';
// import Footer from './Footer.js';
// const Form2 = () => {
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const campaignName = queryParams.get('campaignName');
//   const navigate = useNavigate();
//   const initialFormState = {
//     AuthCustomSocial: "",
//     productSS: "",
//     order: "",
//     city: "",
//     pinCode: "",
//     UPI: "",
//     paymentMethod: "",
//     accountNumber: "",
//     ifsc: "",
//     beneficiaryName: "",
//     bankName: "",
//     whatsappGroup: "",
//     inputValue: "",
//     inputValue1: "",
//     inputValue2: "",
//     inputValue3: "",
//     inputValue4: "",
//     starRating: "",
//     sellerFeedbackScreenshot: "",
//     invoiceReceived: "",
//     invoiceNumber: "",
//     profileVisibility: "",
//     product1: "",
//     contactId: "",
//     campaignName: "",
//   };

//   const [data, setData] = useState({});
//   // const [fullName, setFullName] = useState('');
//   // const [orderId, setOrderId] = useState('');
//   // const [upiId, setUpiId] = useState('');
//   // const [bankAccountNumber, setBankAccountNumber] = useState('');
//   // const [ifscCode, setIfscCode] = useState('');
//   // const [beneficiaryName, setBeneficiaryName] = useState('');
//   // const [bankName, setBankName] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [showMessage, setShowMessage] = useState(false);
//   const [selectedBank, setSelectedBank] = useState('');
//   const [products, setProducts] = useState([{ name: '', quantity: '', ss: null, amount: '' }]);
//   const [formData, setFormData] = useState(() => {
//     // Load initial form data from localStorage
//     const savedFormData = localStorage.getItem('formData');
//     const storedUserId = localStorage.getItem("loggedInUserId");

//     return savedFormData
//       ? JSON.parse(savedFormData)
//       : {
//         AuthCustomSocial: "",
//         productSS: "",
//         order: "",
//         city: "",
//         pinCode: "",
//         UPI: "",
//         paymentMethod: "",
//         accountNumber: "",
//         ifsc: "",
//         beneficiaryName: "",
//         bankName: "",
//         whatsappGroup: "",
//         inputValue: "",
//         inputValue1: "",
//         inputValue2: "",
//         inputValue3: "",
//         inputValue4: "",
//         starRating: "",
//         sellerFeedbackScreenshot: "",
//         invoiceReceived: "",
//         invoiceNumber: "",
//         profileVisibility: "",
//         product1: "",
//         contactId: "",
//         campaignName: "",
//       };
//   });
//   useEffect(() => {
//     localStorage.setItem('formData', JSON.stringify(formData));
//   }, [formData]);
//   useEffect(() => {
//     if (campaignName) {
//       const fetchData = async () => {
//         try {
//           const response = await axios.get(`${Config.API_URL}/api/templategetREfund/${campaignName}`);


//           console.log('Fetched data:', response.data);

//           const filteredData = response.data.reduce((acc, item) => ({ ...acc, ...item }), {});

//           setData(filteredData);
//         } catch (error) {
//           console.error('Error fetching form data:', error);
//         }
//       };
//       fetchData();
//     }
//   }, [campaignName]);
//   // const handleClearStorage = () => {
//   //   localStorage.clear();
//   //   setFormData({
//   //     AuthCustomSocial: '',
//   //     AuthYouTube: '',
//   //     AuthTwitter: '',
//   //     AuthFacebook: '',
//   //     AuthInstagram: '',
//   //     productSS: '',
//   //     order: '',
//   //     city: '',
//   //     pinCode: '',
//   //     UPI: '',
//   //     paymentMethod: '',
//   //     accountNumber: '',
//   //     ifsc: '',
//   //     quantity: '',
//   //     beneficiaryName: '',
//   //     bankName: '',
//   //     whatsappGroup: '',
//   //     inputValue: '',
//   //     inputValue1: '',
//   //     inputValue2: '',
//   //     inputValue3: '',
//   //     inputValue4: '',
//   //     starRating: '',
//   //     sellerFeedbackScreenshot: '',
//   //     invoiceReceived: '',
//   //     invoiceNumber: '',
//   //     profileVisibility: '',
//   //     product1: '',
//   //     contactId: ''
//   //   });
//   // };
//   const handleClearStorage = () => {
//     localStorage.removeItem('formData'); // ❌ Don't clear entire localStorage
//     setFormData({ ...initialFormState }); // ✅ Reset form only
//   };
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get(`${Config.API_URL}/api/product`, {
//           params: { campaignName }, // Send campaign name as a query parameter
//         });
//         setProducts(response.data); // Set fetched products to state
//       } catch (error) {
//         console.error("Error fetching products:", error);
//         console.log("Error fetching products:", error);
//       }
//     };

//     if (campaignName) {
//       fetchProducts(); // Fetch products when campaignName changes
//     }
//   }, [campaignName]);
//   const handleFormChange = (event) => {
//     const { name, value, type, checked } = event.target;
//     setFormData(prevData => ({
//       ...prevData,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setShowMessage(true);
//     setLoading(true);

//     const userId = localStorage.getItem("loggedInUserId");
//     if (!userId) {
//       alert("User ID not found. Please log in again.");
//       setLoading(false);
//       return;
//     }

//     // Add userId to formData
//     const completeFormData = {
//       ...formData,
//       userId: userId, // Add userId here
//     };

//     const formPayload = new FormData();
//     for (const key in completeFormData) {
//       formPayload.append(key, completeFormData[key]);
//     }

//     if (completeFormData.inputValue3) {
//       formPayload.append("productSS", completeFormData.inputValue3);
//     }

//     try {
//       const response = await axios.post(`${Config.API_URL}/api/submit-form`, formPayload, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       // console.log('Form submitted successfully:', response.data)
//       toast.success("Form submitted successfully!");
//       setTimeout(() => {
//         navigate('/live-user');
//       }, 1500);
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.error ||
//         "Failed to submit form. Please try again."
//       );
//       console.error('Error submitting form:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         inputValue3: file,  // Use appropriate state key for each file input
//       }));
//     }
//   };

//   const handleFileUpload1 = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         inputValue4: file,
//       }));
//     }
//   };

//   const handleFileUpload2 = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         sellerFeedbackScreenshot: file,
//       }));
//     }
//   };
//   const handleFileUpload3 = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevData) => ({
//         ...prevData,
//         invoiceReceived: file,
//       }));
//     }
//   };
//   const handleBankChange = (e) => {
//     const value = e.target.value;
//     setSelectedBank(value);
//     setFormData((prevData) => ({
//       ...prevData,
//       bankName: value,  // ✅ This will include bankName in form submission
//     }));
//   };

//   const handleCancel = () => {
//     localStorage.removeItem('formData'); // Clear only form data
//     setFormData({ ...initialFormState }); // Reset to defaults
//     window.location.reload();
//   };
//   const fieldStyle = {
//     width: "100%",
//     borderRadius: "4px",
//   };

//   return (
//     <>
//       <Header />
//       <div className='card' style={{ width: "1248px", left: "35px", right: "40px" }}>
//         {loading && (
//           <div className="loader-overlay">
//             <div className="loader"></div>
//           </div>
//         )}
//         <form onSubmit={handleSubmit}>

//           <div style={{ display: "flex", justifyContent: "center" }}>
//             <h2 style={{ fontFamily: "Roboto", fontWeight: "600", width: "374px", marginTop: "75px" }}>
//               Refund Form
//             </h2>
//           </div>
//           <div style={{ marginLeft: "25px", marginRight: "25px" }}>
//             <h2 style={{ fontFamily: "Roboto", fontWeight: "500", width: "259px", marginTop: "40px" }}>
//               Instructions Before Filling the Form:
//             </h2>
//             <h2 style={{ fontFamily: "Roboto", fontWeight: "500", maxWidth: "1059px", fontSize: "12px", marginTop: "10px" }}>
//               Please fill out all required fields carefully and ensure that your contact, order, and payment details are accurate. Incomplete or incorrect submissions may be rejected. By submitting this form, you confirm that you agree to the terms and conditions of the campaign.
//             </h2>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//                 gap: "20px",
//               }}
//             >
//               <div className="field" style={fieldStyle}>
//                 <label className="label">Contact Id</label>
//                 <div className="control">
//                   <input
//                     className="input"
//                     type="text"
//                     name="contactId"
//                     placeholder="Contact id received via mail"
//                     value={formData.contactId}
//                     onChange={handleFormChange}
//                     required
//                   />
//                 </div>
//               </div>

//               {data.order && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Order Id</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="order"
//                       placeholder="Order Id"
//                       value={formData.order}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.AuthCustomSocial && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Custom Account Holder Name</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="AuthCustomSocial"
//                       placeholder="Account holder name"
//                       value={formData.AuthCustomSocial}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.paymentMethod && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Payment Method</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="paymentMethod"
//                       placeholder="Bank Account or UPI ID"
//                       value={formData.paymentMethod}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.accountNumber && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Bank Account Number</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="accountNumber"
//                       placeholder="Bank Account Number"
//                       value={formData.accountNumber}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           handleFormChange(e);
//                         }
//                       }}
//                       inputMode="numeric"
//                       maxLength={18}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.ifsc && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">IFSC Code</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="ifsc"
//                       placeholder="IFSC Code"
//                       value={formData.ifsc}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.beneficiaryName && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Beneficiary Name</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="beneficiaryName"
//                       placeholder="Beneficiary Name"
//                       value={formData.beneficiaryName}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.bankName && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">Bank Name</label>
//                   <BankDropdown selectedBank={selectedBank} handleBankChange={handleBankChange} />
//                 </div>
//               )}

//               {data.UPI && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">UPI ID</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="UPI"
//                       placeholder="UPI ID"
//                       value={formData.UPI}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue1 && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue1}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="inputValue1"
//                       value={formData.inputValue1}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue2 && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue2}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="inputValue2"
//                       value={formData.inputValue2}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue3 && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue3}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="inputValue3"
//                       accept="image/*"
//                       onChange={handleFileUpload}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.inputValue4 && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.inputValue4}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="inputValue4"
//                       accept="image/*"
//                       onChange={handleFileUpload1}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.sellerFeedbackScreenshot && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.sellerFeedbackScreenshot}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="sellerFeedbackScreenshot"
//                       accept="image/*"
//                       onChange={handleFileUpload2}
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.invoiceReceived && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.invoiceReceived}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="file"
//                       name="invoiceReceived"
//                       accept="image/*"
//                       onChange={handleFileUpload3}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.invoiceNumber && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.invoiceNumber}</label>
//                   <div className="control">
//                     <input
//                       className="input"
//                       type="text"
//                       name="invoiceNumber"
//                       placeholder="Invoice Number"
//                       value={formData.invoiceNumber}
//                       onChange={handleFormChange}
//                       required
//                     />
//                   </div>
//                 </div>
//               )}

//               {data.starRating && (
//                 <div className="field" style={fieldStyle}>
//                   <label className="label">{data.starRating}</label>
//                   <div className="control">
//                     <div className="select is-fullwidth">
//                       <select
//                         name="starRating"
//                         value={formData.starRating}
//                         onChange={handleFormChange}
//                         required
//                       >
//                         <option value="" disabled>Select Rating</option>
//                         {[1, 2, 3, 4, 5].map((val) => (
//                           <option key={val} value={val}>{val}</option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//               )}


//               {/* )} */}

//               {/* Only render if whatsappGroup is true */}
//               {data.whatsappGroup === true && (
//                 <div className="field">
//                   <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "12px", height: "23px" }}>Have You Joined <img
//                     src="../images/whatsapp (2).png"
//                     alt="Logo"
//                     style={{ height: "13px", width: "13px", objectFit: "contain" }}
//                   /> Whatsapp Group</label>
//                   <label className="radio" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
//                     <input
//                       type="radio"
//                       name="whatsappGroup"
//                       value="yes"
//                       checked={formData.whatsappGroup === 'yes'}
//                       onChange={handleFormChange}
//                       required
//                     />
//                     Yes
//                   </label>
//                   <label className="radio" style={{ marginLeft: "10px", fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
//                     <input
//                       type="radio"
//                       name="whatsappGroup"
//                       value="no"
//                       checked={formData.whatsappGroup === 'no'}
//                       onChange={handleFormChange}
//                     />
//                     No
//                   </label>
//                 </div>
//               )}
//             </div>

//             <div className="field is-small">
//               <label className="checkbox" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", top: "6px" }}>
//                 <input
//                   type="checkbox"
//                   required
//                 />
//                 Agree to{' '}
//                 <a href="//hobo.video/terms-conditions-for-an-influencer" target="_blank" rel="noopener noreferrer" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
//                   Terms and Conditions
//                 </a>
//               </label>
//             </div>
//             <button className="button" onClick={handleClearStorage} style={{
//               marginLeft: "1010px", marginTop: "-90px"
//             }} >
//               Clear all
//             </button>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "20px", // space between buttons
//                 marginTop: "24px",
//               }}
//             >
//               <button
//                 className="button"
//                 type="submit"
//                 style={{ minWidth: "507px", marginLeft: "30px", marginBottom: "15px" }}
//               >
//                 {loading ? <div className="loader"></div> : "Submit"}
//               </button>

//               <button
//                 className="button"
//                 type="button"
//                 onClick={handleCancel} // define this function
//                 style={{ minWidth: "507px", marginLeft: "40px", marginBottom: "15px" }}
//               >
//                 Cancel
//               </button>
//             </div>

//           </div>
//         </form >

//         {showMessage && (
//           <div className="thank-you-message">
//             <h1>Form Submited successfully</h1>
//             <p>Thank you for submitting the form!</p>
//           </div>
//         )
//         }
//       </div >
//       <Footer />
//     </>
//   );
// };
// export default Form2;
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from "react-toastify";
import { Config } from '../.env.js';
import { useLocation, useNavigate } from 'react-router-dom';
import BankDropdown from './bank.js';
import "./style.css";
import IFSCSearch from './findifsc.js';
import Header from './Header.js';
import Footer from './Footer.js';
const Form2 = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const campaignName = queryParams.get('campaignName');
  const navigate = useNavigate();
  const initialFormState = {
    AuthCustomSocial: "",
    productSS: "",
    order: "",
    city: "",
    pinCode: "",
    UPI: "",
    paymentMethod: "",
    accountNumber: "",
    ifsc: "",
    beneficiaryName: "",
    bankName: "",
    whatsappGroup: "",
    inputValue: "",
    inputValue1: "",
    inputValue2: "",
    inputValue3: "",
    inputValue4: "",
    starRating: "",
    sellarFeedbackScreenshot: "",
    invoiceReceived: "",
    invoiceNumber: "",
    profileVisibility: "",
    product1: "",
    contactId: "",
    campaignName: "",
  };

  const [data, setData] = useState({});
  // const [fullName, setFullName] = useState('');
  // const [orderId, setOrderId] = useState('');
  // const [upiId, setUpiId] = useState('');
  // const [bankAccountNumber, setBankAccountNumber] = useState('');
  // const [ifscCode, setIfscCode] = useState('');
  // const [beneficiaryName, setBeneficiaryName] = useState('');
  // const [bankName, setBankName] = useState('');
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [selectedBank, setSelectedBank] = useState('');
  const [products, setProducts] = useState([{ name: '', quantity: '', ss: null, amount: '' }]);
  const [formData, setFormData] = useState(() => {
    // Load initial form data from localStorage
    const savedFormData = localStorage.getItem('formData');
    const storedUserId = localStorage.getItem("loggedInUserId");

    return savedFormData
      ? JSON.parse(savedFormData)
      : {
        AuthCustomSocial: "",
        productSS: "",
        order: "",
        city: "",
        pinCode: "",
        UPI: "",
        paymentMethod: "",
        accountNumber: "",
        ifsc: "",
        beneficiaryName: "",
        bankName: "",
        whatsappGroup: "",
        inputValue: "",
        inputValue1: "",
        inputValue2: "",
        inputValue3: "",
        inputValue4: "",
        starRating: "",
        sellarFeedbackScreenshot: "",
        invoiceReceived: "",
        invoiceNumber: "",
        profileVisibility: "",
        product1: "",
        contactId: "",
        campaignName: "",
      };
  });
  useEffect(() => {
    localStorage.setItem('formData', JSON.stringify(formData));
  }, [formData]);
  useEffect(() => {
    if (campaignName) {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${Config.API_URL}/api/templategetREfund/${campaignName}`);


          console.log('Fetched data:', response.data);

          const filteredData = response.data.reduce((acc, item) => ({ ...acc, ...item }), {});

          setData(filteredData);
        } catch (error) {
          console.error('Error fetching form data:', error);
        }
      };
      fetchData();
    }
  }, [campaignName]);
  // const handleClearStorage = () => {
  //   localStorage.clear();
  //   setFormData({
  //     AuthCustomSocial: '',
  //     AuthYouTube: '',
  //     AuthTwitter: '',
  //     AuthFacebook: '',
  //     AuthInstagram: '',
  //     productSS: '',
  //     order: '',
  //     city: '',
  //     pinCode: '',
  //     UPI: '',
  //     paymentMethod: '',
  //     accountNumber: '',
  //     ifsc: '',
  //     quantity: '',
  //     beneficiaryName: '',
  //     bankName: '',
  //     whatsappGroup: '',
  //     inputValue: '',
  //     inputValue1: '',
  //     inputValue2: '',
  //     inputValue3: '',
  //     inputValue4: '',
  //     starRating: '',
  //     sellerFeedbackScreenshot: '',
  //     invoiceReceived: '',
  //     invoiceNumber: '',
  //     profileVisibility: '',
  //     product1: '',
  //     contactId: ''
  //   });
  // };
  const handleClearStorage = () => {
    localStorage.removeItem('formData'); // ❌ Don't clear entire localStorage
    setFormData({ ...initialFormState }); // ✅ Reset form only
  };
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${Config.API_URL}/api/product`, {
          params: { campaignName }, // Send campaign name as a query parameter
        });
        setProducts(response.data); // Set fetched products to state
      } catch (error) {
        console.error("Error fetching products:", error);
        console.log("Error fetching products:", error);
      }
    };

    if (campaignName) {
      fetchProducts(); // Fetch products when campaignName changes
    }
  }, [campaignName]);
  const handleFormChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowMessage(true);
    setLoading(true);

    const userId = localStorage.getItem("loggedInUserId");
    if (!userId) {
      alert("User ID not found. Please log in again.");
      setLoading(false);
      return;
    }

    // Add userId to formData
    const completeFormData = {
      ...formData,
      userId: userId, // Add userId here
    };

    const formPayload = new FormData();
    for (const key in completeFormData) {
      formPayload.append(key, completeFormData[key]);
    }

    if (completeFormData.inputValue3) {
      formPayload.append("productSS", completeFormData.inputValue3);
    }

    try {
      const response = await axios.post(`${Config.API_URL}/api/submit-form`, formPayload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      // console.log('Form submitted successfully:', response.data)
      toast.success("Form submitted successfully!");
      setTimeout(() => {
        navigate('/live-user');
      }, 1500);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        "Failed to submit form. Please try again."
      );
      console.error('Error submitting form:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        inputValue3: file,  // Use appropriate state key for each file input
      }));
    }
  };

  const handleFileUpload1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        inputValue4: file,
      }));
    }
  };

  const handleFileUpload2 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        sellarFeedbackScreenshot: file,
      }));
    }
  };
  const handleFileUpload3 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        invoiceReceived: file,
      }));
    }
  };
  const handleBankChange = (e) => {
    const value = e.target.value;
    setSelectedBank(value);
    setFormData((prevData) => ({
      ...prevData,
      bankName: value,  // ✅ This will include bankName in form submission
    }));
  };

  const handleCancel = () => {
    localStorage.removeItem('formData'); // Clear only form data
    setFormData({ ...initialFormState }); // Reset to defaults
    window.location.reload();
  };
  const fieldStyle = {
    width: "100%",
    borderRadius: "4px",
  };

  return (
    <>
      <Header />
      <div className='card' style={{ width: "1248px", left: "35px", right: "40px" }}>
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        <form onSubmit={handleSubmit}>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <h2 style={{ fontFamily: "Roboto", fontWeight: "600", width: "374px", marginTop: "75px" }}>
              Refund Form
            </h2>
          </div>
          <div style={{ marginLeft: "25px", marginRight: "25px" }}>
            <h2 style={{ fontFamily: "Roboto", fontWeight: "500", width: "259px", marginTop: "40px" }}>
              Instructions Before Filling the Form:
            </h2>
            <h2 style={{ fontFamily: "Roboto", fontWeight: "500", maxWidth: "1059px", fontSize: "12px", marginTop: "10px" }}>
              Please fill out all required fields carefully and ensure that your contact, order, and payment details are accurate. Incomplete or incorrect submissions may be rejected. By submitting this form, you confirm that you agree to the terms and conditions of the campaign.
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                gap: "20px",
              }}
            >
              <div className="field" style={fieldStyle}>
                <label className="label">Contact Id</label>
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    name="contactId"
                    placeholder="Contact id received via mail"
                    value={formData.contactId}
                    onChange={handleFormChange}
                    required
                  />
                </div>
              </div>

              {data.order && (
                <div className="field" style={fieldStyle}>
                  <label className="label">Order Id</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="order"
                      placeholder="Order Id"
                      value={formData.order}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.AuthCustomSocial && (
                <div className="field" style={fieldStyle}>
                  <label className="label">Custom Account Holder Name</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="AuthCustomSocial"
                      placeholder="Account holder name"
                      value={formData.AuthCustomSocial}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.paymentMethod && (
                <div className="field" style={fieldStyle}>
                  <label className="label">Payment Method</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="paymentMethod"
                      placeholder="Bank Account or UPI ID"
                      value={formData.paymentMethod}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.accountNumber && (
                <div className="field" style={fieldStyle}>
                  <label className="label">Bank Account Number</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="accountNumber"
                      placeholder="Bank Account Number"
                      value={formData.accountNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          handleFormChange(e);
                        }
                      }}
                      inputMode="numeric"
                      maxLength={18}
                      required
                    />
                  </div>
                </div>
              )}

              {data.ifsc && (
                <div className="field" style={fieldStyle}>
                  <label className="label">IFSC Code</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="ifsc"
                      placeholder="IFSC Code"
                      value={formData.ifsc}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.beneficiaryName && (
                <div className="field" style={fieldStyle}>
                  <label className="label">Beneficiary Name</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="beneficiaryName"
                      placeholder="Beneficiary Name"
                      value={formData.beneficiaryName}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.bankName && (
                <div className="field" style={fieldStyle}>
                  <label className="label">Bank Name</label>
                  <BankDropdown selectedBank={selectedBank} handleBankChange={handleBankChange} />
                </div>
              )}

              {data.UPI && (
                <div className="field" style={fieldStyle}>
                  <label className="label">UPI ID</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="UPI"
                      placeholder="UPI ID"
                      value={formData.UPI}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.inputValue && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.inputValue}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="inputValue1"
                      value={formData.inputValue}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.inputValue2 && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.inputValue2}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="inputValue2"
                      value={formData.inputValue2}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.inputValue3 && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.inputValue3}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="file"
                      name="inputValue3"
                      accept="image/*"
                      onChange={handleFileUpload}
                      required
                    />
                  </div>
                </div>
              )}

              {data.inputValue4 && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.inputValue4}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="file"
                      name="inputValue4"
                      accept="image/*"
                      onChange={handleFileUpload1}
                      required
                    />
                  </div>
                </div>
              )}

              {data.sellerFeedbackScreenshot && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.sellerFeedbackScreenshot}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="file"
                      name="sellarFeedbackScreenshot"
                      accept="image/*"
                      onChange={handleFileUpload2}
                    />
                  </div>
                </div>
              )}

              {data.invoiceReceived && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.invoiceReceived}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="file"
                      name="invoiceReceived"
                      accept="image/*"
                      onChange={handleFileUpload3}
                      required
                    />
                  </div>
                </div>
              )}

              {data.invoiceNumber && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.invoiceNumber}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="invoiceNumber"
                      placeholder="Invoice Number"
                      value={formData.invoiceNumber}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>
              )}

              {data.starRating && (
                <div className="field" style={fieldStyle}>
                  <label className="label">{data.starRating}</label>
                  <div className="control">
                    <div className="select is-fullwidth">
                      <select
                        name="starRating"
                        value={formData.starRating}
                        onChange={handleFormChange}
                        required
                      >
                        <option value="" disabled>Select Rating</option>
                        {[1, 2, 3, 4, 5].map((val) => (
                          <option key={val} value={val}>{val}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}


              {/* )} */}

              {/* Only render if whatsappGroup is true */}
              {data.whatsappGroup === true && (
                <div className="field">
                  <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "12px", height: "23px" }}>Have You Joined <img
                    src="../images/whatsapp (2).png"
                    alt="Logo"
                    style={{ height: "13px", width: "13px", objectFit: "contain" }}
                  /> Whatsapp Group</label>
                  <label className="radio" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
                    <input
                      type="radio"
                      name="whatsappGroup"
                      value="yes"
                      checked={formData.whatsappGroup === 'yes'}
                      onChange={handleFormChange}
                      required
                    />
                    Yes
                  </label>
                  <label className="radio" style={{ marginLeft: "10px", fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
                    <input
                      type="radio"
                      name="whatsappGroup"
                      value="no"
                      checked={formData.whatsappGroup === 'no'}
                      onChange={handleFormChange}
                    />
                    No
                  </label>
                </div>
              )}
            </div>

            <div className="field is-small">
              <label className="checkbox" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", top: "6px" }}>
                <input
                  type="checkbox"
                  required
                />
                Agree to{' '}
                <a href="//hobo.video/terms-conditions-for-an-influencer" target="_blank" rel="noopener noreferrer" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
                  Terms and Conditions
                </a>
              </label>
            </div>
            <button className="button" onClick={handleClearStorage} style={{
              marginLeft: "1010px", marginTop: "-90px"
            }} >
              Clear all
            </button>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px", // space between buttons
                marginTop: "24px",
              }}
            >
              <button
                className="button"
                type="submit"
                style={{ minWidth: "507px", marginLeft: "30px", marginBottom: "15px" }}
              >
                {loading ? <div className="loader"></div> : "Submit"}
              </button>

              <button
                className="button"
                type="button"
                onClick={handleCancel} // define this function
                style={{ minWidth: "507px", marginLeft: "40px", marginBottom: "15px" }}
              >
                Cancel
              </button>
            </div>

          </div>
        </form >

        {showMessage && (
          <div className="thank-you-message">
            <h1>Form Submited successfully</h1>
            <p>Thank you for submitting the form!</p>
          </div>
        )
        }
      </div >
      <Footer />
    </>
  );
};
export default Form2;